import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import Nav from './Nav.js';
import Home from './Home.js';
import Product from './Product.js';
import Services from './Services.js';
import About from './About.js';
import Blog from './Blog.js';
import Footer from './Footer.js';
import Contact from './Contact.js';
// import '../node_modules/use.fontawesome.com/releases/v5.15.4/css/all.css'


function App() {

  return (
    <div className="App">

     
     <BrowserRouter>

        <Nav/>

        <Routes>
          <Route path='*' element={<Home/>}/>
          <Route path='/Home' element={<Home/>}/>
          <Route path='/Product' element={<Product/>}/>
          <Route path='/About' element={<About/>}/>
          <Route path='/Services' element={<Services/>}/>
          <Route path='/Blog' element={<Blog/>}/>
          <Route path='/Contact' element={<Contact/>}/>
        </Routes>

        <Footer/>
     
     </BrowserRouter>

    </div>
  );
}

export default App;
